import { ReportFilterDataType } from "../../Shared/Enums/ReportFilterDataType"
import { IFilter, ReportFilter, ReportFilterOption } from "../../Shared/ReportFilter"
import _ from 'underscore'

export function findRecursive(found: Array<ReportFilter>, result: Array<IFilter>) {
    found.forEach(item => {
        result.push(item)
        if (item.subFilters.length > 0) {
            item.subFilters.forEach(subitem => {
                result.push(subitem)
                if (subitem.subFilters) {
                    findRecursive(subitem.subFilters, result)
                }
            })
        } else if (item.defaultValues.length > 0) {
            item.defaultValues.forEach(subitem => {
                result.push(subitem)
                if (subitem.filters) {
                    findRecursive(subitem.filters, result)
                }
            })
        }
    })
}

export function refreshFiltersState(arr: Array<IFilter>) {
    const found: Array<IFilter> = _.filter(arr, function (f: IFilter) { return f.childGroups !== null && (f.childGroups != undefined && f.childGroups.length > 0) })
    if (found) {
        let checkeds: Array<string> = []
        let unchecked: Array<string> = []
        found.forEach(item => {
            let checked: boolean | undefined = undefined;
            let arrayOfProps = Object.getOwnPropertyNames(item);
            let found = _.find(arrayOfProps, function (f: string) { return f === 'values' })
            if (found) {
                const rf = item as ReportFilter
                checked = rf.values.length == 0 ? false : JSON.parse(rf.values[0].toLowerCase()) === true
            } else {
                found = _.find(arrayOfProps, function (f: string) { return f === 'value' })
                if (found) {
                    const fo = item as ReportFilterOption
                    if (fo) {
                        checked = fo.checked
                    }
                }
            }

            if (checked != undefined) {
                if (checked) {
                    item.childGroups?.forEach(f => {
                        checkeds.push(f)
                    })
                } else {
                    item.childGroups?.forEach(f => {
                        unchecked.push(f)
                    })
                }
            }
        })

        if (checkeds.length > 0) {
            if (checkeds.length > 1) {
                checkeds = checkeds.filter((value, index) => checkeds.indexOf(value) === index)
            }
            checkeds.forEach(u => {
                const toEnable: Array<IFilter> = _.filter(arr, function (f: IFilter) { return f.group?.id === u })
                toEnable.forEach(d => {
                    d.disabled = false
                })
            })
        }

        if (unchecked.length > 0) {
            if (unchecked.length > 1) {
                unchecked = unchecked.filter((value, index) => unchecked.indexOf(value) === index)
            }
            unchecked.forEach(u => {
                const toDisable: Array<IFilter> = _.filter(arr, function (f: IFilter) { return f.group?.id === u })
                toDisable.forEach(d => {
                    d.disabled = true
                })
            })
        }
    }
}

export function calculateFilterWeights(filters: Array<ReportFilter>) {
    filters.forEach(filter => {
        calculateFilterWeight(filter)
    })
}

export function calculateFilterWeight(filter: ReportFilter) {
    //ToDo by resolution
    if (filter.colSpan == null) {
        switch (filter.dataType) {
            case ReportFilterDataType.GroupBox:
            case ReportFilterDataType.Grid:
            case ReportFilterDataType.SinglePlugin:
            case ReportFilterDataType.MultiPlugin:
                filter.colSpan = 3
                break
            case ReportFilterDataType.Period:
            case ReportFilterDataType.TimePeriod:
                filter.colSpan = 2
                break
            case ReportFilterDataType.Boolean:
            case ReportFilterDataType.CheckList:
            case ReportFilterDataType.CheckListAdv:
            case ReportFilterDataType.Date:
            case ReportFilterDataType.Integer:
            case ReportFilterDataType.Float:
            case ReportFilterDataType.Combo:
            case ReportFilterDataType.Label:
            case ReportFilterDataType.String:
            case ReportFilterDataType.RadioGroup:
                filter.colSpan = 1
                break
            default:
                filter.colSpan = 1
                break;
        }
    }
    if (filter.subFilters.length > 0){
        filter.subFilters.forEach(sfilter => {
            calculateFilterWeight(sfilter)
        })
    }
}

const cols: number = 6

export function calculateRows(filters: Array<ReportFilter>) {
    let rowNumber = 0
    let counter: number = 0
    filters.forEach(filter => {
        const colSpan: number = filter.colSpan as number
        const counterWithSpan = counter + colSpan 
        if (counterWithSpan <= cols) {
            counter = counterWithSpan
        } else {
            rowNumber++
            counter = colSpan
        }
        filter.row = rowNumber
        if (filter.rowBreak) {
            rowNumber++
            counter = 0
        }
    })
}

export class ReportFilterRow{
    row: number
    filters: Array<ReportFilter>

    constructor(row: number, filters: Array<ReportFilter>) {
        this.row = row
        this.filters = filters
    }
}

export function getRows(filters: Array<ReportFilter>): Array<ReportFilterRow> {
    const rows: Array<ReportFilterRow> = []
    const rowNumbers: Array<number> = []

    filters.forEach(filter => {
        const contains = _.contains(rowNumbers, filter.row)
        if (!contains) {
            const rowNumber = filter.row as number
            rowNumbers.push(rowNumber)
            rows.push(new ReportFilterRow(rowNumber, []))
        }
    })

    rowNumbers.forEach(rowNumber => {
        const found = _.filter(filters, (f: ReportFilter) => { return f.row == rowNumber; });
        if (found.length > 0) {
            const row = rows[rowNumber]
            found.forEach(f => {
                row.filters.push(f)
            })
        }
    })

    return rows
}